import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wellness',
  templateUrl: './wellness.component.html',
  styleUrls: ['./wellness.component.scss']
})
export class WellnessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
